import styled from '@emotion/styled';
import { css } from '@emotion/core';
import {
	BaseCell,
	BaseHeader,
} from '../../../flights/overview/ui/list/columns/Column';
import { Responsive } from '../../../../ui';
import { columnHeaderStyles } from './shared';

interface IPolicyNumberCellProps {
	number: string;
}

const styles = css`
	display: flex;
	width: 100px;
	max-width: 100px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		max-width: none;
	}
`;

const StyledHeader = styled(BaseHeader)`
	${styles}
	${columnHeaderStyles}
`;

const StyledCell = styled(BaseCell)`
	${styles}
	font-weight: 500;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		grid-area: number;
	}
`;

export function Header() {
	return <StyledHeader>Number</StyledHeader>;
}

export function Cell({ number }: IPolicyNumberCellProps) {
	return <StyledCell>{number}</StyledCell>;
}
